import React, { useState } from 'react';
import { Icon } from '@fikasio/react-ui-components';
import Button from 'react-bootstrap/Button';
import { useTranslation } from 'react-i18next';
import { Entity } from 'services/entities/types';
import EntitiesList from './EntitiesList';
import SelectionBar from 'components/UI/SelectionBar';
import AddEntityButton from './AddEntityButton';

const EntitiesView = ({
  entities,
}) => {
  const { t } = useTranslation();
  const [viewMode, setViewMode] = useState('LIST');
  const [selectedEntities, setSelectedEntities] = useState<Entity[]>([]);

  const handleSelectEntity = entity => {
    const isEntityAlreadySelected = selectedEntities.find(a => a.id === entity.id);
    if (isEntityAlreadySelected) {
      setSelectedEntities([
        ...selectedEntities.filter(a => a.id !== entity.id),
      ]);
    } else {
      setSelectedEntities([
        ...selectedEntities,
        entity,
      ]);
    }
  };

  let entityView;
  if (viewMode === 'LIST') {
    entityView = (
      <EntitiesList
        entities={entities}
        onEntitySelect={handleSelectEntity}
        onSelectAllEntities={entitiesArray => setSelectedEntities(entitiesArray)}
        selectedEntities={selectedEntities}
      />
    );
  } else {
    entityView = null;
  }

  return (
    <>
      <div>
        <AddEntityButton
          style={{
            float: 'right',
            marginRight: 0,
          }}
        />
        <Button
          variant="outline-secondary"
          active={viewMode === 'LIST'}
          onClick={() => setViewMode('LIST')}
        >
          <Icon name="list" size="1x" />
        </Button>
        <Button
          onClick={() => setViewMode('BOARD')}
          active={viewMode === 'BOARD'}
          variant="outline-secondary"
        >
          <Icon name="th" size="1x" />
        </Button>
      </div>
      { entityView }
      {
        selectedEntities.length > 0 && (
          <SelectionBar>
            <Icon
              name="times"
              onClick={() => {
                setSelectedEntities([]);
              }}
              style={{
                cursor: 'pointer',
                marginRight: 10,
                width: 25,
              }}
            />
            <b>
              {t('xSelectedEntities', { count: selectedEntities.length })}
            </b>
          </SelectionBar>
        )
      }
    </>
  );
};

export default EntitiesView;
